import script from "./admin_user.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_user.vue?vue&type=script&setup=true&lang=js"

import "./admin_user.vue?vue&type=style&index=0&id=1d5dbafa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5dbafa"]])

export default __exports__